"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.toUpperCaseFirstLetter = void 0;

var _format = _interopRequireDefault(require("date-fns/format"));

var toUpperCaseFirstLetter = function toUpperCaseFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

exports.toUpperCaseFirstLetter = toUpperCaseFirstLetter;

var formatDigest = function formatDigest(schedule) {
  if (schedule.period === "Instant") return "Instant";else if (!schedule.start) {
    if (!schedule.period) {
      return "";
    }

    return toUpperCaseFirstLetter(schedule.period) + " UTC";
  }
  var formatted = getScheduleString(schedule);
  return toUpperCaseFirstLetter(formatted);
};

var getScheduleString = function getScheduleString(schedule) {
  var _schedule$repeat4, _schedule$repeat5;

  if ((schedule === null || schedule === void 0 ? void 0 : schedule.recurrence) === "custom") {
    var _schedule$repeat, _schedule$repeat2, _schedule$repeat3;

    var scheduleString = "Every ".concat(schedule === null || schedule === void 0 ? void 0 : (_schedule$repeat = schedule.repeat) === null || _schedule$repeat === void 0 ? void 0 : _schedule$repeat.frequency, " ").concat(schedule === null || schedule === void 0 ? void 0 : (_schedule$repeat2 = schedule.repeat) === null || _schedule$repeat2 === void 0 ? void 0 : _schedule$repeat2.interval, "(s)");

    switch (schedule === null || schedule === void 0 ? void 0 : (_schedule$repeat3 = schedule.repeat) === null || _schedule$repeat3 === void 0 ? void 0 : _schedule$repeat3.interval) {
      case "week":
        scheduleString += " on ".concat(getWeekdaysRepeatOnString(schedule === null || schedule === void 0 ? void 0 : (_schedule$repeat4 = schedule.repeat) === null || _schedule$repeat4 === void 0 ? void 0 : _schedule$repeat4.on));
        break;

      case "month":
        scheduleString += " on ".concat(schedule === null || schedule === void 0 ? void 0 : (_schedule$repeat5 = schedule.repeat) === null || _schedule$repeat5 === void 0 ? void 0 : _schedule$repeat5.on, " of the month");
        break;

      default:
        scheduleString += "";
    }

    if (schedule !== null && schedule !== void 0 && schedule.end) {
      scheduleString += typeof schedule.end === "number" ? " (".concat(schedule.end, " occurrences)") : " (until ".concat((0, _format["default"])(new Date(schedule.end), "MM-dd-yyyy"), ")");
    }

    return scheduleString;
  }

  if ((schedule === null || schedule === void 0 ? void 0 : schedule.recurrence) === "instant") {
    return "Instant";
  }

  return "".concat(schedule === null || schedule === void 0 ? void 0 : schedule.recurrence, " at ").concat((0, _format["default"])(new Date(schedule === null || schedule === void 0 ? void 0 : schedule.start), "h:mmaaaaa'm'" // lowercase am/pm while date-fns is older than 2.23.0
  ));
};

var getWeekdaysRepeatOnString = function getWeekdaysRepeatOnString(repeatOn) {
  var weekdays = Object.keys(repeatOn).map(function (weekday) {
    if (repeatOn[weekday]) {
      return "".concat(weekday.charAt(0).toUpperCase()).concat(weekday.substring(1, 3));
    }
  }).filter(Boolean);
  return weekdays.join(", ");
};

var _default = formatDigest;
exports["default"] = _default;